import { axiosWithJWT } from '@/api/axiosWithJWT';

export const getTourStatus = async (_) => {
  const { data } = await axiosWithJWT.get('/api/TourStatus/GetList');
  return data;
};
